import { Reveal } from "@frontend/components/site/reveal";
import { Section } from "@frontend/components/site/section";

const BOUNDARIES = [
  {
    n: "01",
    title: "Never holds your money",
    body: "No escrow. No payment gateway. They pay your UPI or bank directly. We only record what each side says happened.",
  },
  {
    n: "02",
    title: "Never takes a cut",
    body: "No commission on advances or balances. Pricing will be a subscription for the tool — not a percentage of what you’re paid.",
  },
  {
    n: "03",
    title: "Never a marketplace",
    body: "No discovery, browsing, matching, or bidding your rate down. Your people stay yours. This only replaces the thread.",
  },
];

export function Boundaries() {
  return (
    <Section className="bg-ink text-white" data-nav-dark>
      <Reveal>
        <p className="mkt-kicker mkt-kicker-light">Where the line is</p>
        <h2 className="mkt-display mt-4 max-w-3xl text-4xl leading-[1.05] text-balance sm:text-5xl lg:text-[3.5rem]">
          Three things we will <span className="mkt-serif text-[#5ff29d]">never do</span>
        </h2>
      </Reveal>

      <ul className="mt-12 border-t border-white/15">
        {BOUNDARIES.map((item, index) => (
          <Reveal
            key={item.title}
            as="li"
            delay={index * 80}
            className="border-b border-white/15 last:border-b-0"
          >
            <div className="mkt-boundary grid grid-cols-[2.75rem_minmax(0,1fr)] gap-x-4 gap-y-2 py-7 sm:grid-cols-[4.5rem_minmax(0,15rem)_minmax(0,1fr)] sm:items-start sm:gap-x-8 sm:gap-y-0 lg:py-9">
              <span className="mkt-display tabular text-xl leading-[1.35] text-white/30 sm:text-2xl sm:leading-[1.3]">
                {item.n}
              </span>
              <h3 className="mkt-display text-xl leading-[1.35] sm:text-2xl sm:leading-[1.3]">
                {item.title}
              </h3>
              <p className="col-start-2 text-[15px] leading-relaxed text-white/55 sm:col-start-3 sm:text-base">
                {item.body}
              </p>
            </div>
          </Reveal>
        ))}
      </ul>
    </Section>
  );
}
